import { render, staticRenderFns } from "./LeadDetailsModal.vue?vue&type=template&id=66b5b3b6"
import script from "./LeadDetailsModal.vue?vue&type=script&lang=js"
export * from "./LeadDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports